module.exports = __webpack_public_path__ + "media/images/icons/outlined/cloud-upload-3db59e0659611bd1bb8f2c54163a01c8.svg";